const ALL_THERAPISTS = [
  {
    id: "navya-chawla",
    calSlug: "therapy-with-navya",
    name: "Navya Chawla",
    first_name: "Navya",
    credentials: "MSc Psychology",
    languages: ["English", "Hindi", "Punjabi"],
    experience: null,
    expertise: ["Stress management", "Relationship dynamics", "Anxiety & self-image", "Anger management"],
    concerns: ["stress", "relationships", "anxiety", "self-esteem"],
    approach: "Client-centred and eclectic, rooted in evidence-based integrative therapies.",
    about:
      "Navya works with a client-centred, eclectic approach rooted in evidence-based integrative therapies. She is trained in supporting individuals through anxiety, self-image and other neurotic concerns, and in helping them develop a steadier sense of self.",
    good_fit: [
      "You're carrying stress that never quite switches off",
      "The same relationship patterns keep repeating",
      "Anger or self-doubt has been running the show",
      "You want to understand yourself, not just cope",
    ],
    image: "/images/navya.jpg",
  },
  {
    id: "swathi",
    calSlug: "therapy-with-swathi", // TODO: placeholder — confirm real Cal.id slug
    hidden: true, // temporarily hidden — bring back once confirmed
    name: "Swathi",
    first_name: "Swathi",
    credentials: "M.Sc (Clinical Psychology)",
    languages: ["English", "Tamil", "Malayalam", "Hindi", "Kannada"],
    experience: "8 years",
    expertise: ["CBT, REBT & ACT", "Trauma-informed psychotherapy", "Couple conflicts", "Anxiety, OCD & depression"],
    concerns: ["anxiety", "trauma", "relationships", "stress"],
    approach: "Structured, evidence-based therapy (CBT, REBT, ACT) with a trauma-informed lens.",
    about:
      "With 8 years of experience across a diverse clientele, Swathi believes seeking help is a sign of strength. Her work focuses on helping people navigate emotional dysregulation in a healthy, sustainable way.",
    good_fit: [
      "Anxiety, OCD or low moods are wearing you down",
      "You're working through something from the past",
      "You and your partner keep having the same fight",
      "You want structured, practical tools — not just talk",
    ],
    image: "/images/swathi.jpg",
  },
  {
    id: "alaisha-singh",
    calSlug: "therapy-with-alaisha",
    name: "Alaisha Engineer",
    first_name: "Alaisha",
    credentials: "MSc Applied Psychology (Clinical Psychology)",
    languages: ["English", "Hindi", "Gujarati"],
    experience: "1.5 years",
    expertise: [
      "Anxiety",
      "Depression",
      "Behavioral Problems",
      "Life Stressors",
      "Low Confidence",
      "Poor Self-Esteem",
      "Relationships and Interpersonal Conflicts",
      "Stress and Burnout",
      "Neurodivergent adults",
      "Caregiver burnout",
    ],
    concerns: ["anxiety", "stress", "self-esteem", "relationships"],
    approach: "Person-Centred Therapy, with elements of Cognitive Behavioural Therapy (CBT) where appropriate.",
    about:
      "The first session with Alaisha is a safe and non-judgmental space to get to know each other and discuss what has brought you to therapy. Together, you'll explore the concerns you'd like support with and what you hope to work towards — there's no pressure to share everything at once, and you can move at a pace that feels comfortable for you.",
    good_fit: [
      "Anxiety, depression, or low confidence has been weighing on you",
      "You're navigating stress, burnout, or a difficult relationship",
      "You're a neurodivergent adult looking for a space that gets it",
      "You're supporting someone else and feeling the weight of caregiver burnout",
    ],
    image: "/images/alaisha.jpeg",
  },
  {
    id: "shamika-singh",
    calSlug: null,
    hidden: true, // no confirmed Cal.id event type yet — keep off the site for now
    name: "Shamika Singh",
    first_name: "Shamika",
    credentials: "Master's in Clinical Psychology",
    languages: ["English", "Hindi"],
    experience: null,
    expertise: ["Thought-related concerns", "Stress & adjustment", "Trauma", "Self & identity"],
    concerns: ["stress", "trauma", "self-esteem", "relationships"],
    approach: "Gentle and collaborative, rooted in trust and awareness.",
    about:
      "Shamika holds space for stories and emotions with a gentle, collaborative approach rooted in trust and awareness. Her work focuses on seeing — and validating — the parts of you that need it most.",
    good_fit: [
      "Your mind won't stop looping the same thoughts",
      "A big life change has knocked you off balance",
      "You're not sure who you are anymore",
      "You want to feel genuinely heard, not analysed",
    ],
    image: "/images/shamika.jpg",
  },
  {
    id: "malvika",
    calSlug: "therapy-with-malvika-krishnan",
    name: "Malvika Krishnan",
    first_name: "Malvika",
    credentials: "MSc Positive Clinical Psychology (Netherlands), MSc Psychology (Clinical)",
    languages: ["English", "Hindi", "Kannada", "Tamil"],
    experience: "7 years",
    expertise: [
      "Personal Development",
      "Identity Building",
      "Relationship Concerns",
      "Betrayal",
      "Trauma Recovery",
      "Depression",
      "Anxiety",
      "Social Anxiety",
      "Abuse",
      "Addiction",
      "ADHD",
      "Anger",
      "Behavioral Problems",
      "Career",
      "Communication",
      "Education",
      "Interpersonal Conflicts",
      "Intimacy",
      "LGBTQIA+ wellness",
      "Life management & deaddiction counselling",
      "Life stressors",
      "Low confidence",
      "Marital Problems",
      "Mood Disorders",
      "Negative Thoughts",
      "Personal growth",
      "Poor self-esteem",
      "Relationships",
      "Female Sexual Wellness",
      "Stress",
      "Suicidal Behaviour",
      "Time Management",
      "Trauma",
    ],
    concerns: ["anxiety", "relationships", "self-esteem", "trauma"],
    approach: "Positive Psychology Interventions, ACT, Mindfulness-based CBT, REBT, and Narrative Therapy.",
    about:
      "In our first session, Malvika ensures a safe, non-judgemental space where you can explore your experience and what concerns bring you here. She believes everyone deserves a space of their own to reflect and grow, and is honoured to co-create that space for her clients.",
    good_fit: [
      "You're working through betrayal or a difficult relationship",
      "Social anxiety makes connection feel exhausting",
      "You're recovering from trauma and want a steady, safe space",
      "You want to understand and rebuild your sense of self",
    ],
    image: "/images/Malvika.jpeg",
  },
];

export const THERAPISTS = ALL_THERAPISTS.filter((t) => !t.hidden);

export function getTherapistById(id) {
  return THERAPISTS.find((t) => t.id === id) || null;
}

export const CAL_TEAM_SLUG = "eunoia";
